<template>
  <div>
    <filtroProjetosLote @filtroPrjetosLote="filtrarProjetosLote" @limparGrid="limparGrid" :sqLote="sqLote"/>

    <div class="text-center" v-if="loadingGridProjetos === true">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>

    <gridProjetos v-else :importacao="true" :items="projetosLote" />
  </div>
</template>

<script>
import filtroProjetosLote from "@/components/astec/projetos/lotesImportacao/filtroProjetosLote";
import gridProjetos       from "@/components/astec/projetos/gridProjetos";

export default {
  components: {
    filtroProjetosLote,
    gridProjetos
  },
  data() {
    return {
      projetosLote       : [],
      sqLote             : null,
      loadingGridProjetos: false,
    };
  },
  created(){
    const sqAstecIntegracaoLote = localStorage.getItem("sqAstecIntegracaoLote");

    if(sqAstecIntegracaoLote){
      this.sqLote = parseInt(sqAstecIntegracaoLote);

      const filtro = {
        sq_astec_integracao_lote: this.sqLote
      }

      this.filtrarProjetosLote(filtro);
    }
  },
  methods: {
    async filtrarProjetosLote(filtro){
      this.loadingGridProjetos = true;

      await this.$http.get("/api/astec/projetos/importarProjetos/getProjetosLote", {
        params: {...filtro}
      })
      .then((response) => {

        this.projetosLote = response.data.projetos;
        this.$refs.accordionFiltroProjetosLote.fechar();
        this.$tools.fecharMenu();

      })
      .catch((error) =>{

        this.$tools.alerta(error.response.data.message, "error");
        this.limparGrid();

      })
      .finally(() =>{

        this.loadingGridProjetos = false;

      });
    },
    limparGrid() {
      this.projetosLote = [];
    }
  }
};
</script>
